import dayjs from "dayjs";
import { formatDate } from "../../UI/Utils/formatDate.ts";

export type ManualBonusType =
  | "all_you_can_speak"
  | "extra_lessons"
  | "extra_weeks";

export type ManualBonusFormInput = {
  type: ManualBonusType;
  // all_you_can_speak
  lessonsCountedPerWeek?: number;
  activeFrom?: string;
  activeTo?: string;
  // extra_lessons
  extraLessons?: number;
  // extra_weeks
  extraWeeks?: number;
};

// Bonus windows are stored as UTC week boundaries (Sunday 00:00 → Saturday 23:59:59.999).
// Rendering them in browser-local time pushes the closing boundary into the next day for
// every timezone east of UTC, so both display and editing pin to UTC.
export function toBonusDateInputValue(date?: string): string {
  return date ? dayjs(date).utc().format("YYYY-MM-DD") : "";
}

function formatBonusPeriod(bonus: ManualBonusFormInput): string {
  const fmt = (d: string) => formatDate(dayjs(d).utc(), { locale: "it" });
  if (bonus.activeFrom && bonus.activeTo)
    return ` · ${fmt(bonus.activeFrom)} → ${fmt(bonus.activeTo)}`;
  if (bonus.activeFrom) return ` · da ${fmt(bonus.activeFrom)}`;
  if (bonus.activeTo) return ` · fino al ${fmt(bonus.activeTo)}`;
  return " · tutta la durata del piano";
}

export function formatBonus(bonus: ManualBonusFormInput): string {
  if (bonus.type === "all_you_can_speak") {
    const lessons =
      bonus.lessonsCountedPerWeek === 0
        ? "illimitato"
        : `${bonus.lessonsCountedPerWeek} lezioni/settimana`;
    return `All You Can Speak — ${lessons}${formatBonusPeriod(bonus)}`;
  }
  if (bonus.type === "extra_lessons") {
    return `Extra Lessons — +${bonus.extraLessons} lezioni`;
  }
  if (bonus.type === "extra_weeks") {
    return `Extra Weeks — +${bonus.extraWeeks} settimane`;
  }
  return bonus.type;
}
